<template>
  <div v-loading.fullscreen.lock="fullscreenLoading"></div>
</template>

<script>
export default {
  name: 'loginIDaaS',
  data() {
    return {
      fullscreenLoading: true,
      currentTenantGuid: '',
      currentuser: {},
      codeList: [],
      tUrl: '',
      platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
      appSideGuid: 'f2cb03a2b3e84149df939753f9825054',
      userStatusType: 1,
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 去往新企业端系统
    goToNewEnterprise(tenantGuid) {
      console.log(tenantGuid);
      const systemEnv = localStorage.systemEnv; // 后端环境
      const envMap = {
        pro: 'https://scm-plus.csyaoly.com/loginAccess',
        pre: 'https://scm-plus.cs4pl.com/loginAccess',
        sit: 'http://localhost:8080/loginAccess',
      };
      const commonParams = [
        `tenantGuid=${tenantGuid}`,
        `token=${localStorage.token}`,
        `refreshToken=${localStorage.refreshToken}`,
      ]
        .filter(Boolean)
        .join('&');
      window.location.href = `${envMap[systemEnv]}?${commonParams}`;
    },
    async init() {
      const self = this;
      const code = self.$route.query.code;

      let validateUri = 'http://localhost:8084/LoginIDaaS';
      let appkey = '69648538e4b0c6ac84adcc52';// 测试id
      // 此项目没有测试环境 发版直接使用正式环境 本地调试注释即可
      appkey = '699eba3de4b0ede30d15a072'; // 生产id
      validateUri = window.location.origin + '/LoginIDaaS';
      const params = {
        userStatusType: self.userStatusType,
        userType: 2,
        platformGuid: self.platformGuid,
        appSideGuid: self.appSideGuid,

        code: code,
        appkey: appkey,
        validateUri: validateUri,
      };
      try {
        // 删除 token
        localStorage.removeItem('token');
        const { data } = await self.api.postJson('/csbr-zuul/staff/login', params);
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          self.$router.push('/Login');
          return;
        }
        localStorage.setItem(
          'wynToken',
          JSON.stringify('670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'),
        );
        localStorage.setItem('token', data.data.token);
        localStorage.token = data.data.token;
        self.$store.commit('$_setStorage', data.data.token);
        localStorage.setItem('refreshToken', data.data.refreshToken);
        await self.getCurrentuser();
        await self.getLastLogin();
        const tenantList = JSON.parse(localStorage.tenantList);
        const currentGuid = this.currentTenantGuid || tenantList[0]?.guid;
        const descData = JSON.parse(localStorage.descData);
        // 新企业端 登录
        if (descData?.loginType == 1) {
          self.goToNewEnterprise(currentGuid);
          return;
        }
        await self.getCurrentstaff(currentGuid);
        await self.getMenuList(currentGuid);
      } catch (error) {
        console.error('error', error);
      }
    },

    async getCurrentuser() {
      let self = this;
      const { data } = await self.api.get('/ms-customer-service/tenant/data/get-tenants-by-currentuser');
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }

      localStorage.tenantList = JSON.stringify(data.data);
      localStorage.systemEnv = data.data[0].systemEnvironment;
    },
    async getLastLogin() {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msCommonAdminPlatformAuthService}/user/get-latest-login-info`,
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      this.currentTenantGuid = data.data.latestLoginTenantGuid;
    },
    async getCodeList() {
      let that = this;
      const { data } = await that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-all`);
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        that.$message.error(data.msg);
        return;
      }
      localStorage.setItem('codeList', JSON.stringify(data.data));
    },
    async getAddRedis(tenantGuid) {
      let self = this;
      const { data } = await self.api.get(
        `/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`,
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
    },
    async getCurrentstaff(tenantGuid) {
      let self = this;
      const { data } = await self.api.get(
        '/ms-personnel-service/staff/data/get-currentstaff?' + `tenantGuid=` + tenantGuid,
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      self.$store.commit('$_setUserId', data.data.userGuid);
      localStorage.setItem('userInfo', JSON.stringify(data.data));
    },
    getMenuList(tenantGuid) {
      let self = this;
      self.api
        .get(
          '/ms-common-admin-platform-auth-service/menu/data/get-menu-by-currentuser?' +
            `appType=01&tenantGuid=` +
            tenantGuid +
            `&appSideIdentifier=QYD`,
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == '00000') {
            self.menuList = res.data.data;
            localStorage.setItem('menuList', JSON.stringify(self.menuList));
            self.$message.success('登录成功');
            const loginIDass = JSON.parse(localStorage.getItem('loginIDass'));
            setTimeout(function () {
              if (res.data.data[0].menuName == '主页') {
                self.$router.push({
                  path: res.data.data[0].path,
                  query: {
                    // username: self.ruleForm.username,
                    // password: self.$md5(self.ruleForm.password),
                    // currentTenantGuid: tenantGuid,
                    // logoTitle: self.logoTitle,
                    // token: localStorage.token,
                    logoTitle: loginIDass.logoTitle,
                    username: loginIDass.username,
                    password: loginIDass.password,
                    currentTenantGuid: tenantGuid,
                    token: localStorage.token,
                    refreshToken: localStorage.refreshToken,
                  },
                });
              }
            }, 100);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style></style>
